export const SET_INTENDED_LEVEL_OF_STUDY = "SET_INTENDED_LEVEL_OF_STUDY";
export const SET_ENTRY_TERM = "SET_ENTRY_TERM";
export const SET_INTENDED_MAJOR = "SET_INTENDED_MAJOR";
export const SET_GPA = "SET_GPA";
export const SET_TEST_SCORES = "SET_TEST_SCORES";
export const SET_PROSPECT_PROFILE_STATE = "SET_PROSPECT_PROFILE_STATE";
